{
  "localeInternationalCountryCode": "CN",
  "PhoneInput": {
    "placeholder": "输入电话号码",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "选择国家",
    "emptyCountries": "未找到国家",
    "emptyDisplay": "-",
    "groupCommon": "常用",
    "groupAllCountries": "所有国家"
  }
}
